module.exports = __webpack_public_path__ + "img/Time Icon.6b198a70.png";